import moment from 'moment';
import { TableCell, Tooltip } from '@material-ui/core';

function TimeAgoTableCell(props) {
	const value = props.item[props.config.key];
	const date = moment(value);
	const isEmpty = value == null || value === '' || !date.isValid();
	const isInDay = () => moment().diff(date, 'days') <= 1;

	return (
		<TableCell className='p-4 md:p-16' scope='row'>
			{isEmpty && <div>-</div>}

			{!isEmpty && isInDay() && <div className='flex items-center'>
				<Tooltip title={date.format('YYYY.M.DD HH:mm:ss')} placement='bottom'>
					<div>{date.fromNow()}</div>
				</Tooltip>
			</div>}

			{!isEmpty && !isInDay() && <div>{date.format('YYYY.M.DD HH:mm:ss')}</div>}

		</TableCell>
	);
}

export default TimeAgoTableCell;
